__webpack_require__.p = "/check-my-repo/";